<template>
  <container title='产业结构分析' :loading='loading' :nodata='nodata' style='margin-top: 13px;height: 418px;'>
    <div id='industrialStructureAnalysis' style='height: 362px;'/>
  </container>
</template>

<script>
  import container from "../container";
  import {industrialStructureAnalysis} from "../../../../../api/bigData";

  export default {
    name: "industrialStructureAnalysis",
    components: {
      container,
    },
    data() {
      return {
        colors:[
          '#17C5CA','#FEAB67','#77EFB6','#AB90DF','#B8E986','#E15E68',
        ],
        myChart:null,
        list:[],
        loading:false,
        nodata:false,
      }
    },
    methods: {
      initEcharts(data) {
        this.myChart =null
        var echarts = require('echarts');
        this.myChart = echarts.init(document.getElementById('industrialStructureAnalysis'));
        let option = {
          tooltip: {
            trigger: 'item',
            formatter: '{b} : ({c}%)',
          },
          legend: {
            left: 14,
            bottom: 0,
            itemWidth: 10,
            itemHeight: 10,
            textStyle: {
              color: "#B8D7FF",
              fontSize:16
            },
          },
          series: [
            {
              type: 'pie',
              radius: ['22%', '50%'],
              center: ['50%', '40%'],
              label: {
                fontSize:14,
                color:"#B8D7FF",
              },
              labelLine:{
                lineStyle:{
                  color:"#B8D7FF",
                },
              },
              data:data
            },

          ]
        };
        this.myChart.setOption(option)
        this.myChart.on('click', (params) =>{
          console.log(params);
          let query={name:params.data.name}
          this.$router.push({path: '/industryStructure',query})
        })
      },
      init(){
        this.loading=true
        industrialStructureAnalysis({}).then(res => {
          let data = res.data
          if (data.code === '000') {
            let list=data.content.list
            for (let i = 0; i < list.length; i++) {
              list[i].value=list[i].rate
              list[i].itemStyle={
                color:this.colors[i]
              }
            }
            this.loading=false
            this.list=list
            this.$nextTick(function () {
              this.initEcharts(list)
            })
          } else {

          }
        }).catch(err => {
          console.log(err);
        }).finally(() => {
          this.loading=false
          this.nodata=!this.list.length
        })
      },
    },
    created() {
      this.init()
    },
  }
</script>

<style scoped lang="scss">
  .industrialStructureAnalysis {

  }
</style>
